import React from 'react';
import { XCircle, AlertOctagon, Pill } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-teal-50 py-16 px-4" data-id="element-182">
      <div className="max-w-5xl mx-auto" data-id="element-183">
        <div className="flex items-center justify-center mb-10" data-id="element-184">
          <AlertOctagon size={32} className="text-orange-500 mr-3" data-id="element-185" />
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-186">
            The Uncomfortable Truth
          </h2>
        </div>
        <div className="bg-white rounded-lg shadow-md p-8 mb-12" data-id="element-187">
          <h3 className="text-2xl font-semibold text-gray-800 mb-6 text-center" data-id="element-188">
            Every small decision matters more than you think
          </h3>
          <div className="space-y-6 mb-8" data-id="element-189">
            <div className="flex items-start" data-id="element-190">
              <XCircle size={24} className="text-orange-500 mr-3 mt-1 flex-shrink-0" data-id="element-191" />
              <p className="text-lg text-gray-700" data-id="element-192">
                Every "a little won't hurt"... actually does hurt.
              </p>
            </div>
            <div className="flex items-start" data-id="element-193">
              <XCircle size={24} className="text-orange-500 mr-3 mt-1 flex-shrink-0" data-id="element-194" />
              <p className="text-lg text-gray-700" data-id="element-195">
                Every "healthy" snack is a disguised trap.
              </p>
            </div>
            <div className="flex items-start" data-id="element-196">
              <XCircle size={24} className="text-orange-500 mr-3 mt-1 flex-shrink-0" data-id="element-197" />
              <p className="text-lg text-gray-700" data-id="element-198">
                Every fast food meal is a silent pact with disease.
              </p>
            </div>
          </div>
          <div className="bg-teal-50 p-6 rounded-lg" data-id="element-199">
            <div className="flex items-start" data-id="element-200">
              <Pill size={28} className="text-teal-600 mr-3 mt-1 flex-shrink-0" data-id="element-201" />
              <div data-id="element-202">
                <h4 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-203">
                  And the most perverse thing...
                </h4>
                <p className="text-lg text-gray-700" data-id="element-204">
                  We've been programmed to believe the only way out... is
                  pharmacological.
                </p>
                <p className="text-lg text-gray-700 mt-2" data-id="element-205">
                  As if your body were broken.
                </p>
                <p className="text-lg text-gray-700 mt-2" data-id="element-206">
                  As if you were born defective.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-207">
          <p className="text-xl text-gray-800" data-id="element-208">
            Are you ready to learn the truth that will change your health
            forever?
          </p>
        </div>
      </div>
    </section>;
}